import { ApolloClient, InMemoryCache, split } from "@apollo/client";
import { createUploadLink } from "apollo-upload-client";
import { BatchHttpLink } from "@apollo/client/link/batch-http";
import { SubscriptionClient } from "subscriptions-transport-ws";
import { WebSocketLink } from "@apollo/client/link/ws";
import { getMainDefinition } from "@apollo/client/utilities";

let previousWsClient: SubscriptionClient | null = null;

export function CreateApolloClient(token: string) {
  const endpoint = (window as any).setting.endpoint as string;
  const uri = endpoint + "/?token=" + token;
  const ws: string = (window as any).setting.ws as string;
  // const ws = "wss://graph-stage.l192.com/graphql";
  const uploadLink = createUploadLink({ uri });
  const batch = new BatchHttpLink({ uri, batchMax: 3, batchInterval: 20, batchDebounce: true });

  if (previousWsClient) {
    previousWsClient.close(true, true);
  }

  const wsClient = new SubscriptionClient(
    ws ? ws : endpoint.replace("https://", "wss://").replace("http://", "ws://") + "/graphql",
    {
      reconnect: true,
      timeout: 30000,
      connectionParams: {
        authToken: token,
      },
    },
  );

  previousWsClient = wsClient;

  const wsLink = new WebSocketLink(wsClient);

  const httpLinkSplit = split(
    (operation) => {
      return ["productImageSearch", "upload"].includes(operation.operationName);
    },
    uploadLink,
    batch,
  );

  const allLinkSplit = split(
    ({ query }) => {
      const definition = getMainDefinition(query);
      return definition.kind === "OperationDefinition" && definition.operation === "subscription";
    },
    wsLink,
    httpLinkSplit,
  );

  const client = new ApolloClient({
    link: allLinkSplit,
    name: "seller",
    cache: new InMemoryCache({
      addTypename: true,
      resultCaching: true,
    }),
    defaultOptions: {
      query: {
        fetchPolicy: "network-only",
      },
      watchQuery: {
        fetchPolicy: "network-only",
      },
    },
  });

  return client;
}
